<template>
  <div class="itemContainer">
    <h3>能源管理合同模式 (EMC) 项目回报测算</h3>
    <el-row :gutter="12" class="row-box">
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">项目分成模式选择<i class="red">*</i></p>
          </div>

          <div class="t-a-l">
            <el-radio
              v-model="HVACEMC_BSM_CEBSP"
              :label="0"
              @change="select_HVACEMC_BSM_CEBSP"
              :disabled="disabledAllBtn"
              >固定比例</el-radio
            >
            <!--  -->
            <div class="df-ac-jsb hvacemc_bsm_cebsp mg-b-30">
              <el-col :span="9" class="">
                <p class="font14 els">-昌恩年均分成比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="7">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACEMC_BSM_CEBSP_FP"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input readonly v-model="HVACEMC_BSM_CEBSP_Price">
                  <template slot="append">￥</template>
                </el-input>
              </el-col>
            </div>

            <!--  -->

            <el-radio
              v-model="HVACEMC_BSM_CEBSP"
              :label="1"
              @change="select_HVACEMC_BSM_CEBSP"
              :disabled="disabledAllBtn"
              >浮动比例</el-radio
            >
            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="9" class="">
                <p class="font14 els">-昌恩首年分成比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="7">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACEMC_BSM_CEBSP_P1"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input
                  readonly
                  v-model="HVACEMC_BSM_CEBSP_P1_Price"
                ></el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp">
              <el-col :span="9" class="">
                <p class="font14 els">-昌恩其余分成比例<i class="red">*</i></p>
              </el-col>
              <el-col :span="7">
                <el-input
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  v-model="HVACEMC_BSM_CEBSP_P2"
                >
                  <template slot="append">%</template>
                </el-input>
              </el-col>

              <el-col :span="8">
                <el-input
                  readonly
                  v-model="HVACEMC_BSM_CEBSP_P2_Price"
                ></el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="3" class="flex-direction-column">
        <el-card class="box-card flex1 mg-b-10">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">预测效益系数</p>
          </div>

          <div class="t-a-l">
            <el-col :span="24">
              <el-input
                readonly
                oninput="value=value.replace(/[^\d.]/g,'')"
                v-model="Coeffcient_Efficiency"
                class="font24"
                :class="
                  Coeffcient_Efficiency > 60 && Coeffcient_Efficiency < 80
                    ? 'grayColor'
                    : Coeffcient_Efficiency >= 80
                    ? 'greenColor'
                    : 'redcolor'
                "
              >
              </el-input>
            </el-col>
            <el-col :span="24">
              <p
                style="text-align: left"
                class="sixtyPoints"
                :class="
                  Coeffcient_Efficiency > 60 && Coeffcient_Efficiency < 80
                    ? 'grayColor'
                    : Coeffcient_Efficiency >= 80
                    ? 'greenColor'
                    : 'redcolor'
                "
              >
                * 不可低于60分
              </p>
            </el-col>
          </div>
        </el-card>

        <el-card class="box-card flex1">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">预测分成系数</p>
          </div>

          <div class="t-a-l">
            <el-col :span="24">
              <el-input
                readonly
                v-model="Coefficient_Commission"
                class="font24"
              >
              </el-input>
            </el-col>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">项目回本时效</p>
          </div>

          <div class="t-a-l">
            <el-col :span="24" class="t-a-c echoYear">
              <p class="mg-b-20">回本所需年份</p>
              <el-input readonly v-model="HVACEMC_BEP" class="font24 set_T-A-C">
                <template slot="append"
                  ><span class="font14">年</span></template
                >
              </el-input>
            </el-col>

            <el-col :span="24" class="t-a-c divisibleYear">
              <p class="mg-b-20">可分成年份</p>
              <el-input readonly v-model="HVACEMC_BSP" class="font24 set_T-A-C">
                <template slot="append"
                  ><span class="font14">年</span></template
                >
              </el-input>
            </el-col>
          </div>
        </el-card>
      </el-col>

      <el-col :span="4">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">项目提成比例</p>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb hvacemc_bsm_cebsp mg-b-30 salesPackage">
              <el-col :span="8" class="minWidth">
                <p class="font14">销售包：</p>
              </el-col>
              <el-col :span="16">
                <el-input readonly v-model="HVACEMC_CommissionRate_Sales">
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp mg-b-30">
              <el-col :span="8" class="minWidth">
                <p class="font14">支持包：</p>
              </el-col>
              <el-col :span="16">
                <el-input readonly v-model="HVACEMC_CommissionRate_Supports">
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb hvacemc_bsm_cebsp mg-b-30">
              <el-col :span="8" class="minWidth">
                <p class="font14">总提成：</p>
              </el-col>
              <el-col :span="16">
                <el-input readonly v-model="HVACEMC_CommissionRate_Total">
                  <template slot="append">%</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>

      <el-col :span="7">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l els mg-t-6">项目预测提成金额</p>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb mg-b-10">
              <el-col :span="8" class="">
                <p class="font14"></p>
              </el-col>
              <el-col :span="6">
                <p class="font14 pd-l-20">月均</p>
              </el-col>
              <el-col :span="6">
                <p class="font14 pd-l-20">年均</p>
              </el-col>
              <el-col :span="6">
                <p class="font14 pd-l-20">总值</p>
              </el-col>
            </div>
          </div>

          <div class="t-a-l">
            <div class="df-ac-jsb mg-b-30">
              <el-col :span="8" class="">
                <p class="font14">销售包金额：</p>
              </el-col>
              <el-col :span="6">
                <el-input
                  class="pd0"
                  readonly
                  v-model="HVACEMC_Commission_Sales_MA"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  class="pd0"
                  readonly
                  v-model="HVACEMC_Commission_Sales_AA"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  class="pd0"
                  readonly
                  v-model="HVACEMC_Commission_Sales_Total"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb mg-b-30">
              <el-col :span="8" class="">
                <p class="font14">支持包金额：</p>
              </el-col>
              <el-col :span="6">
                <el-input
                  readonly
                  class="pd0"
                  v-model="HVACEMC_Commission_Supports_MA"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  readonly
                  class="pd0"
                  v-model="HVACEMC_Commission_Supports_AA"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  readonly
                  class="pd0"
                  v-model="HVACEMC_Commission_Supports_Total"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
            </div>

            <div class="df-ac-jsb mg-b-30">
              <el-col :span="8" class="">
                <p class="font14">总提成金额：</p>
              </el-col>
              <el-col :span="6">
                <el-input
                  readonly
                  class="pd0"
                  v-model="HVACEMC_Commission_Total_MA"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  readonly
                  class="pd0"
                  v-model="HVACEMC_Commission_Total_AA"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
              <el-col :span="6">
                <el-input
                  readonly
                  class="pd0"
                  v-model="HVACEMC_Commission_Total_Total"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </el-col>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 第二行 -->
    <el-row :gutter="12" class="EMCBox mg-t-10">
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l mg-t-6 els">甲方EMC项目实际节能收益 (6年)</p>
          </div>
          <div class="t-a-l">
            <el-input
              class=""
              v-model="HVACEMC_Owner_Savings_Total"
              :disabled="false"
            >
              <template slot="append">￥</template>
            </el-input>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l mg-t-6 els">昌恩EMC项目总营收</p>
          </div>
          <div class="t-a-l">
            <el-input
              class=""
              v-model="HVACEMC_CE_Revenue_Total"
              :disabled="false"
            >
              <template slot="append">￥</template>
            </el-input>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l mg-t-6 els">昌恩EMC项目提成前总毛利</p>
          </div>
          <div class="t-a-l">
            <el-input
              class=""
              v-model="HVACEMC_CE_GrossProfitBC_Total"
              :disabled="false"
            >
              <template slot="append">￥</template>
            </el-input>
          </div>
        </el-card>
      </el-col>

      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="df-ac-jsb clearfix">
            <p class="t-a-l mg-t-6 els">昌恩EMC项目实际总毛利</p>
          </div>
          <div class="t-a-l">
            <el-input
              class=""
              v-model="HVACEMC_CE_GrossProfitBC_Total"
              :disabled="false"
            >
              <template slot="append">￥</template>
            </el-input>
            <p class="t-a-l endItemP">
              ({{ HVACEMC_CE_GrossProfit_Margin + "%" }})
            </p>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { symbolOfRMB } from "@/utils/symbolOfRMB";
export default {
  props: ["metadata"],
  data() {
    return {
      disabledAllBtn: true,
      // 项目分成模式选择
      HVACEMC_BSM_CEBSP: "", // 项目分成模式选择--固定0 浮动1
      HVACEMC_BSM_CEBSP_FP: "", // 项目分成模式选择--昌恩年均分成比例
      HVACEMC_BSM_CEBSP_Price: "", // 项目分成模式选择-- 固定比例计算结果
      //浮动比例
      HVACEMC_BSM_CEBSP_P1: "", // 昌恩首年分成比例
      HVACEMC_BSM_CEBSP_P1_Price: "", //昌恩其余分成比例--结果

      HVACEMC_BSM_CEBSP_P2: "", // 昌恩其余分成比例
      HVACEMC_BSM_CEBSP_P2_Price: "", //昌恩其余分成比例--结果

      // 预测效益系数
      Coeffcient_Efficiency: "",
      //分成系数
      Coefficient_Commission: "0",

      // 项目回本时效
      HVACEMC_BEP: "0",
      HVACEMC_BSP: "0",

      // 项目提成比例
      HVACEMC_CommissionRate_Sales: "0",
      HVACEMC_CommissionRate_Supports: "0",
      HVACEMC_CommissionRate_Total: "0",

      // 项目预测提成金额
      HVACEMC_Commission_Sales_Total: "0",
      HVACEMC_Commission_Sales_AA: "0",
      HVACEMC_Commission_Sales_MA: "0",
      HVACEMC_Commission_Supports_Total: "0",
      HVACEMC_Commission_Supports_AA: "0",
      HVACEMC_Commission_Supports_MA: "0",
      HVACEMC_Commission_Total_Total: "0",
      HVACEMC_Commission_Total_AA: "0",
      HVACEMC_Commission_Total_MA: "0",

      // 甲方EMC项目实际节能收益
      HVACEMC_Owner_Savings_Total: "0",
      // 昌恩EMC项目总营收
      HVACEMC_CE_Revenue_Total: "0",
      // 昌恩EMC项目提成前总毛利
      HVACEMC_CE_GrossProfitBC_Total: "0",
      // 昌恩EMC项目实际总毛利
      HVACEMC_CE_GrossProfit_Total: "0",
      HVACEMC_CE_GrossProfit_Margin: "0",

      monthly: "月均",
      year: "年均",
      total: "总值",
    };
  },

  watch: {
    metadata: {
      handler(newval) {
        this.dumpData(newval);
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.$route.query.title) {
      this.$nextTick(() => {
        // 禁用所有编辑按钮
        this.disabledAllBtn = true;
      });
    } else {
      this.disabledAllBtn = false;
    }
  },
  methods: {
    dumpData(data) {
      // 项目暖通系统年用电量
      // 项目分成模式选择
      console.log("固定或浮动", data.HVACEMC_BSM_CEBSP);
      this.HVACEMC_BSM_CEBSP = data.HVACEMC_BSM_CEBSP; // 项目分成模式选择--固定 浮动1
      this.HVACEMC_BSM_CEBSP_FP = (data.HVACEMC_BSM_CEBSP_FP * 100).toFixed(2); // 项目分成模式选择--昌恩年均分成比例
      this.HVACEMC_BSM_CEBSP_Price = symbolOfRMB(data.HVACEMC_BSM_CEBSP_Price); // 项目分成模式选择-- 固定比例计算结果
      //浮动比例
      this.HVACEMC_BSM_CEBSP_P1 = (data.HVACEMC_BSM_CEBSP_P1 * 100).toFixed(2); // 昌恩首年分成比例
      this.HVACEMC_BSM_CEBSP_P1_Price = symbolOfRMB(
        data.HVACEMC_BSM_CEBSP_P1_Price
      ); //昌恩其余分成比例--结果

      this.HVACEMC_BSM_CEBSP_P2 = (data.HVACEMC_BSM_CEBSP_P2 * 100).toFixed(2); // 昌恩其余分成比例
      this.HVACEMC_BSM_CEBSP_P2_Price = symbolOfRMB(
        data.HVACEMC_BSM_CEBSP_P2_Price
      ); //昌恩其余分成比例--结果

      // 预测效益系数
      this.Coeffcient_Efficiency = data.Coeffcient_Efficiency;
      //分成系数
      this.Coefficient_Commission = data.Coefficient_Commission;

      // 项目回本时效
      this.HVACEMC_BEP = data.HVACEMC_BEP;
      this.HVACEMC_BSP = data.HVACEMC_BSP;

      // 项目提成比例
      this.HVACEMC_CommissionRate_Sales = (
        data.HVACEMC_CommissionRate_Sales * 100
      ).toFixed(2);

      this.HVACEMC_CommissionRate_Supports = (
        data.HVACEMC_CommissionRate_Supports * 100
      ).toFixed(2);

      this.HVACEMC_CommissionRate_Total = (
        data.HVACEMC_CommissionRate_Total * 100
      ).toFixed(2);

      // 项目预测提成金额
      this.HVACEMC_Commission_Sales_Total = symbolOfRMB(
        data.HVACEMC_Commission_Sales_Total
      );

      this.HVACEMC_Commission_Sales_AA = symbolOfRMB(
        data.HVACEMC_Commission_Sales_AA
      );
      this.HVACEMC_Commission_Sales_MA = symbolOfRMB(
        data.HVACEMC_Commission_Sales_MA
      );
      this.HVACEMC_Commission_Supports_Total = symbolOfRMB(
        data.HVACEMC_Commission_Supports_Total
      );

      this.HVACEMC_Commission_Supports_AA = symbolOfRMB(
        data.HVACEMC_Commission_Supports_AA
      );
      this.HVACEMC_Commission_Supports_MA = symbolOfRMB(
        data.HVACEMC_Commission_Supports_MA
      );
      this.HVACEMC_Commission_Total_Total = symbolOfRMB(
        data.HVACEMC_Commission_Total_Total
      );
      this.HVACEMC_Commission_Total_AA = symbolOfRMB(
        data.HVACEMC_Commission_Total_AA
      );
      this.HVACEMC_Commission_Total_MA = symbolOfRMB(
        data.HVACEMC_Commission_Total_MA
      );

      // 甲方EMC项目实际节能收益
      this.HVACEMC_Owner_Savings_Total = symbolOfRMB(
        data.HVACEMC_Owner_Savings_Total
      );
      // 昌恩EMC项目总营收
      this.HVACEMC_CE_Revenue_Total = symbolOfRMB(
        data.HVACEMC_CE_Revenue_Total
      );
      // 昌恩EMC项目提成前总毛利
      this.HVACEMC_CE_GrossProfitBC_Total = symbolOfRMB(
        data.HVACEMC_CE_GrossProfitBC_Total
      );
      // 昌恩EMC项目实际总毛利
      this.HVACEMC_CE_GrossProfit_Total = symbolOfRMB(
        data.HVACEMC_CE_GrossProfit_Total
      );
      this.HVACEMC_CE_GrossProfit_Margin = symbolOfRMB(
        data.HVACEMC_CE_GrossProfit_Margin
      );
    },
    // 记录参数
    // rememberInputData() {
    //   let paramsObj = {
    //     HVAC_EnergyConsumption_Annual: removeSymbolOfRMB(
    //       this.HVAC_EnergyConsumption_Annual
    //     ), //项目暖通系统年用电量
    //     HVAC_AveragePSR_Annual: removeSymbolOfRMB(this.HVAC_AveragePSR_Annual), // 年均节能率
    //     Power_UnitPrice: removeSymbolOfRMB(this.Power_UnitPrice), //电费单价
    //     Cost_Construction: removeSymbolOfRMB(this.Cost_Construction), //建设毛成本
    //     Cost_OM_Anuual: removeSymbolOfRMB(this.Cost_OM_Anuual), // 项目运维成本
    //     Loan_Amount: removeSymbolOfRMB(this.Loan_Amount), //项目贷款额
    //     Loan_InterestRate_Annual: this.Loan_InterestRate_Annual, //贷款年利率  (number)
    //     Loan_Term: removeSymbolOfRMB(this.Loan_Term), //贷款年限
    //   };
    //   console.log("当前所有输入参数", paramsObj);
    //   return paramsObj;
    // },

    select_HVACEMC_BSM_CEBSP(val) {
      console.log("val", val);
      if (val == 1) {
        this.showGrey = true;
      } else {
        this.showGrey = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.itemContainer {
  margin: 60px 0;
}

h3 {
  margin: 20px;
}
.row-box {
  display: flex;
  flex-flow: wrap;
}
.row-box .el-card {
  height: 320px;
  border-radius: 8px;
}

.row-box .el-card:hover {
  box-shadow: 0 2px 12px 0 rgb(255 25 255 / 10%);
}

.row-box .EMCBox {
  height: 180px;
}

.hvacemc_bsm_cebsp ::v-deep .el-input__inner {
  text-align: right;
  min-width: 60px;
  padding: 0 10px;
}

::v-deep .el-form-item__label {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 32px;
  text-align: left;
}

.noBorder ::v-deep .el-input__inner {
  border: none !important;
  font-weight: 700;
}
.projectOperation {
  text-align: left;
}
.el-radio-group {
  text-align: left;
}
.el-radio-group .el-radio {
  padding: 8px 0;
}

.redcolor ::v-deep .el-input__inner {
  color: red !important;
}
.grayColor ::v-deep .el-input__inner {
  color: gray !important;
}

.greenColor ::v-deep .el-input__inner {
  color: green !important;
}
.redcolor {
  color: red !important;
}
.grayColor {
  color: gray !important;
}

.greenColor {
  color: green !important;
}
.restFormItemMargin.el-form-item {
  margin-bottom: 0;
}
// 设置input无背景色
.noBgc ::v-deep .el-input__inner {
  background-color: transparent !important;
  color: #303133 !important;
}

// 修改默认的el-form-item  margin
.changeFormItem .el-form-item {
  margin: 0;
}
.changeFormItem .el-input ::v-deep .el-input__inner {
  margin: 10px 0;
}

.clearfix p {
  font-size: 14px;
}
.el-card {
  height: 140px;
  border-radius: 10px;
}
::v-deep .el-card__header {
  height: 60px;
}
::v-deep .el-input-group__append {
  background-color: #fff;
  border: none;
  margin: 0;
  padding: 0;
  text-align: left;
}
.itemContent {
  // width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.year {
  width: 80px;
  font-size: 14px;
}

.formatInput {
  width: 80px;
  border: none;
  outline: none;
}
.el-radio {
  padding: 6px 0;
}
.endItem {
  margin-bottom: 10px;
}
.endItemP {
  margin-top: -10px;
  margin-left: 16px;
}

.el-button {
  border: none !important;
  background-color: transparent;
  color: #303133;
}
.sixtyPoints {
  font-size: 12px;
}
p {
  font-size: 14px;
}
.divisibleYear {
  margin-top: 50px;
}
.set_T-A-C ::v-deep .el-input__inner {
  text-align: center;
}
.salesPackage {
  margin-top: 24px;
}
// .minWidth {
//   width: 70px;
// }
.echoYear {
  // margin-top: 10px;
}

.pd0 ::v-deep .el-input__inner {
  padding: 0;
}
.setLeft ::v-deep .el-input__inner {
  text-align: left;
  padding: 0;
}
.setCenter ::v-deep .el-input__inner {
  text-align: center;
  padding: 0;
}
.setRight ::v-deep .el-input__inner {
  text-align: right;
  padding: 0;
}
::v-deep .el-input-group__prepend {
  background-color: transparent;
  border: none;
  padding: 0;
}
</style>
